import type { InsuranceProduct } from 'src/interfaces/insuranceProduct'

/**
 * In-memory search over the insurance-product catalog. Returns the input array by reference for
 * an empty query so an untouched search box does not churn the caller's `useMemo`.
 */
export const filterInsuranceProducts = (
  products: InsuranceProduct[],
  search: string,
): InsuranceProduct[] => {
  const normalizedSearch = search.trim().toLowerCase()

  if (normalizedSearch === '') {
    return products
  }

  return products.filter((product) => {
    const haystack = [product.name, product.description ?? '', product.explanation ?? '']

    return haystack.some((value) => {
      return value.toLowerCase().includes(normalizedSearch)
    })
  })
}
